var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"news_list_page_back_box"}),_vm._m(0),_c('GameList')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('img',{staticClass:"banner__image",attrs:{"src":require("@/assets/2024/index_cover.svg"),"alt":""}}),_c('img',{staticClass:"mobile-index-background",attrs:{"src":require("@/assets/2024/mobile_index_background.svg"),"alt":""}})])
}]

export { render, staticRenderFns }